import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import config from "../../config";

function MediaDetails() {
    const { id } = useParams();
    const [media, setMedia] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const fetchMediaDetails = async () => {
        try {
            const response = await axios.get(
                `${config.BASE_URL}/api/admin/get-media/${id}`,
                { withCredentials: true }
            );

            setMedia(response.data);
        } catch (err) {
            setError("Failed to fetch media details");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMediaDetails();
    }, [id]);

    const handleDelete = async () => {
        try {
            await axios.delete(
                `${config.BASE_URL}/api/admin/delete-media/${id}`,
                { withCredentials: true }
            );

            navigate("/admin/medias");
        } catch (err) {
            setError("Failed to delete media");
        }
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="dashboard project_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Dashboard</h1>

                <div className="back_btn_wrap">
                    <button
                        className="back-btn"
                        onClick={() => navigate(-1)}
                    >
                        Go Back
                    </button>
                </div>

                <div className="main-section">
                    <div className="projects">
                        <div className="projects-inner">

                            {/* Title */}
                            <div className="detail_item">
                                <h2>Media Title</h2>
                                <div className="detail_item_inner">
                                    <p>{media.title}</p>
                                </div>
                            </div>

                            {/* Video Link */}
                            <div className="detail_item">
                                <h2>Video Link</h2>
                                <div className="detail_item_inner">
                                    <a
                                        href={media.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {media.link}
                                    </a>
                                </div>
                            </div>

                            {/* Uploaded Media */}
                            <div className="detail_item">
                                <div className="detail_banner_wrap">
                                    <div className="detail_img_grid">

                                        {media.mediafile ? (
                                            <div className="detail_img_item">
                                                <h2>Media File</h2>

                                                <div className="banner_img_wrap">
                                                    <img
                                                        src={`${config.BASE_URL}${media.mediafile}`}
                                                        alt={media.title}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <p>No media file available.</p>
                                        )}

                                    </div>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="detail_project_btn_wrap">
                                <div className="detail_edit_del">

                                    <div className="btn_item">
                                        <button
                                            className="detail_btns"
                                            onClick={handleDelete}
                                        >
                                            Delete
                                        </button>
                                    </div>

                                    <div className="btn_item">
                                        <Link
                                            to={`/admin/update-media/${media._id}`}
                                            className="update_detail detail_btns"
                                        >
                                            Edit
                                        </Link>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MediaDetails;